var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE912D",
    d: "m13.473 5.027-4-4a.67.67 0 0 0-.947.946l2.867 2.86H1a.667.667 0 1 0 0 1.334h10.393l-2.867 2.86a.667.667 0 0 0 .217 1.092.67.67 0 0 0 .73-.146l4-4a.666.666 0 0 0 0-.946"
  })));
};
export default SvgLeftArrow;